import { Loading as Load } from './loading.styled'

const Loading = (props) => {
  return <Load {...props} />
}
export default Loading
